import React, {useEffect, useState} from 'react';
import { StyledCookieNotification } from "./styled";
import { Link } from 'react-router-dom'
import { scrollToElement } from '../../utilities/index'
import { useCookies } from "react-cookie";

const CookieNotification = () => {
    const [cookies, setCookie] = useCookies(['omniquadCookiesConfirmation'])
    const [showNotification, setShowNotification] = useState(false)

    function handleConfirmCookies() {
        setCookie('omniquadCookiesConfirmation', "true", {
            path: '/',
            expires: new Date(Date.now() + (365*24*60*60*1000)) // 1 year
        })

        setShowNotification(false)
    }

    useEffect(() => {
        if (cookies.omniquadCookiesConfirmation === undefined) {
            setTimeout(() => {
                setShowNotification(true)
            }, 2000)
        }
    }, [])

    if (! showNotification) {
        return null;
    }


    return (
        <StyledCookieNotification className="Cookie-notification">
            <div>
                We use cookies to monitor Omniquad website usage and performance.
                By continuing, you agree with our <Link to={"/privacy-policy"} onClick={() => scrollToElement("root")}><strong>cookie policy</strong></Link>.
            </div>
            <button onClick={() => handleConfirmCookies()}>Accept and Continue</button>
        </StyledCookieNotification>
    )
}

export default CookieNotification
